// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('resellerorder.resellerorderview', {
        url: '/{orderId}',
        templateUrl: 'main/resellerorder/resellerorderview/resellerorderview.tpl.html',
        controller: 'ResellerOrderViewController as vm',
        resolve: {
            resellerOrder: resellerOrderResolver
        },
        params: {
            searchTerm: '',
            productNumber: '',
            shouldUseScannerNavigation: false
        }
    });
}

// @ngInject
function resellerOrderResolver($stateParams, ResellerOrdersApiService) {
    return ResellerOrdersApiService.getOrderHeaderById($stateParams.orderId);
}

// @ngInject
function ResellerOrderViewController($rootScope, $state, $stateParams, $translate, resellerOrder) {
    var vm = this;

    //Properties
    vm.selectedOrder = resellerOrder.order;
    vm.selectedOrder.links = resellerOrder.links;
    vm.canAccess = $rootScope.canAccess;
    vm.showSearchFields = true;
    vm.productNumberToExpand = $stateParams.productNumber;

    //Public methods
    vm.toggleSearchFields = toggleSearchFields;
    vm.getStatusTranslation = getStatusTranslation;
    vm.getOrderTypeTranslation = getOrderTypeTranslation;
    vm.showSearchToggle = showSearchToggle;

    activate();

    function activate() {
        vm.showSearchFields = true;
        if (vm.selectedOrder && vm.selectedOrder.id) {
            vm.showSearchFields = false;
        }
    }

    function toggleSearchFields() {
        vm.showSearchFields = !vm.showSearchFields;
    }

    function showSearchToggle() {
        return vm.selectedOrder && vm.selectedOrder.id;
    }

    function getStatusTranslation(text) {
        var textCapital = text.substr(0, 1).toUpperCase() + text.substr(1, text.length - 1);
        return $translate.instant('resellerorder.status' + textCapital);
    }

    function getOrderTypeTranslation(text) {
        var textCapital = text.substr(0, 1).toUpperCase() + text.substr(1, text.length - 1);
        return $translate.instant('resellerorder.type' + textCapital);
    }
}

angular
    .module('resellerorder.resellerorderview', [])
    .config(stateConfig)
    .controller('ResellerOrderViewController', ResellerOrderViewController);
